import React, {useCallback, useEffect, useState} from 'react';
import {subjectsApi} from "../../services/services";
import {Card, CardBody, CardHeader, CardTitle, Col, Row} from "reactstrap";

const Subjects = (props) => {
    const [subjects, setSubjects] = useState([])
    const Subject = useCallback(async () => {
        const sub = await subjectsApi(props.Category)
        setSubjects(sub?.data)
    })

    useEffect(() => {
        Subject()
    }, [])

    return (
        <Col sm={12}>
            <Card className={"card-chart"}>
                <CardHeader>
                    <Row>
                        <Col className="text-right font-weight-600" sm="6">
                            <h5 className="card-category font-weight-600">موضوعات</h5>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody className={"text-center pointer"}>
                    {
                        subjects && subjects.map((cat, index) => (
                            <Col sm={4} onClick={()=>props.onSelect(cat.id)} key={index}>
                                <Card className="subject-card">
                                    <CardBody className={"text-right"}>
                                        <CardTitle tag="h5"><i className="tim-icons text-info icon-chart-bar-32"/>&nbsp;&nbsp;{cat.title}</CardTitle>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))
                    }
                </CardBody>
            </Card>

        </Col>
    );
};

export default Subjects;